import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { SearchParams, AddPatientParams } from './patients-sidebar.component';

@Injectable({ providedIn: 'root' })
export class PatientsSidebarService {
  readonly search$ = new Subject<SearchParams>();
  readonly awl$ = new Subject<{ id: string; first: string; last: string; phone: string }>();
  readonly addPatient$ = new Subject<AddPatientParams>();
  readonly openEsearch$ = new Subject<boolean>();
  readonly clear$ = new Subject<void>();
  readonly showHelp$ = new Subject<void>();
  readonly activeNavChange$ = new BehaviorSubject<string | null>(null);
  readonly isAWL$ = new BehaviorSubject<boolean>(false);
  // PatientsComponent owns the fetch, so the sidebar needs this to disable its Search button while one is in flight.
  readonly searching$ = new BehaviorSubject<boolean>(false);
  // Consumed once by the new sidebar instance when navigating to /patsearch from another route.
  pendingNavItem: string | null = null;
  // Consumed once by PatientsComponent on init when Search Exams / Reports was clicked off /patsearch.
  pendingOpenEsearch: boolean | null = null;
  // Consumed once by PatientsComponent on init for a search/today's-list/new-patient triggered off /patsearch (carries the typed terms).
  pendingSearch: SearchParams | null = null;
  pendingAwl: AddPatientParams | null = null;
  pendingAddPatient: AddPatientParams | null = null;
}
